



import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Map,
  User,
  LogOut,
  ChevronDown,
  FolderKanban,
  MapPinned,
  Users,
  Building2,
  Briefcase,
  UserPlus,
  CreditCard,
  Plane,
  Files,
  ShieldCheck, 
  ReceiptText,
  UsersRound,
  
Lock } from "lucide-react";
import Auth from "../Common/Configurations/Auth"; 

function MainHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (Auth.logout) {
        Auth.logout();
    } else {
        localStorage.clear();
    }
    navigate("/"); 
  };

  // --- FIXED HIGHLIGHTING LOGIC ---
  const isActive = (path) => {
    const currentPath = location.pathname;
    
    if (path === "/members") {
      // Highlight "Members" ONLY if it's members, manage, or view, but NOT documents
      return (currentPath === "/members" || 
              currentPath.startsWith("/members/manage") || 
              currentPath.startsWith("/members/view")) && 
              !currentPath.startsWith("/members/documents");
    }
    
    // For all other links, standard startsWith check
    return currentPath.startsWith(path);
  };

  const styles = {
    header: {
      height: "70px",
      backgroundColor: "#ffffff",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 40px",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      borderBottom: "1px solid #f1f5f9"
    },
    logoSection: { display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" },
    logoBox: { width: "38px", height: "38px", background: "linear-gradient(135deg, #e57e46 0%, #1633d8 100%)", borderRadius: "10px", color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" },
    brandName: { margin: 0, fontSize: "20px", fontWeight: "800", letterSpacing: "-0.5px", color: "#0f172a" },
    navLink: (path) => ({
      cursor: "pointer",
      fontSize: "14px",
      padding: "24px 5px",
      color: isActive(path) ? "#4f46e5" : "#64748b",
      fontWeight: isActive(path) ? "700" : "500",
      borderBottom: isActive(path) ? "3px solid #4f46e5" : "3px solid transparent",
      transition: "0.2s"
    }),
    profileToggle: { display: "flex", alignItems: "center", gap: "8px", padding: "6px 12px", backgroundColor: "#f8fafc", borderRadius: "12px", cursor: "pointer", border: "1px solid #e2e8f0", transition: "0.2s" },
    dropdown: { position: "absolute", top: "55px", right: 0, width: "220px", backgroundColor: "#fff", boxShadow: "0 10px 25px rgba(0,0,0,0.1)", borderRadius: "16px", border: "1px solid #e2e8f0", overflow: "hidden", padding: "8px" },
    dropdownItem: { display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", cursor: "pointer", fontSize: "14px", color: "#475569", borderRadius: "10px", transition: "0.2s" }
  };

  return (
    <div style={styles.header}>
    


<div onClick={() => navigate("/dashboard")} style={styles.logoSection}>
  <div style={styles.logoBox}>
    <MapPinned size={22} strokeWidth={2.5} />
  </div>

  <h2 style={styles.brandName}>
    <span
      style={{
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        textDecorationThickness: "2px",
      }}
    >
      Ma
    </span>
    g
    <span
      style={{
        color: "#56b06f",
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        textDecorationThickness: "2px",
      }}
    >
      nets
    </span>
  </h2>
</div>

      <div style={{ display: "flex", gap: "30px" }}>
        <span style={styles.navLink("/dashboard")} onClick={() => navigate("/dashboard")}>Dashboard</span>
         <span style={styles.navLink("/members")} onClick={() => navigate("/members")}>Members</span>
         <span style={styles.navLink("/receipts")} onClick={() => navigate("/receipts")}>Receipts</span>
          <span style={styles.navLink("/members/documents")} onClick={() => navigate("/members/documents")}>Documents</span>
         <span style={styles.navLink("/leads")} onClick={() => navigate("/leads")}>Leads</span>
         <span style={styles.navLink("/holidays")} onClick={() => navigate("/holidays")}>Holidays</span>
        
       
        
       
        
      </div>

      <div style={{ position: "relative" }} ref={dropdownRef}>
        <div onClick={() => setShowDropdown(!showDropdown)} style={styles.profileToggle}>
          <div style={{ width: "28px", height: "28px", backgroundColor: "#4f46e5", borderRadius: "8px", color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}><User size={16} /></div>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{Auth.getFullName()}</span>
          <ChevronDown size={14} color="#64748b" />
        </div>

        {showDropdown && (
          <div style={styles.dropdown}>

             <div style={styles.dropdownItem} onClick={() => {navigate("/company-profile"); setShowDropdown(false)}}><Building2  size={16} /> Company Profile</div>
          
            <div style={styles.dropdownItem} onClick={() => {navigate("/agents"); setShowDropdown(false)}}><Users size={16} /> Agents</div>
            <div style={styles.dropdownItem} onClick={() => {navigate("/projects"); setShowDropdown(false)}}><FolderKanban size={16} /> Projects</div>
            <div style={styles.dropdownItem} onClick={() => {navigate("/plots"); setShowDropdown(false)}}><MapPinned size={16} /> Plots</div>
            <div style={styles.dropdownItem} onClick={() => {navigate("/branches"); setShowDropdown(false)}}><Building2 size={16} /> Branches</div>
            <div style={styles.dropdownItem} onClick={() => {navigate("/designations"); setShowDropdown(false)}}><Briefcase size={16} /> Designations</div>
            {/* <div style={styles.dropdownItem} onClick={() => {navigate("/leads"); setShowDropdown(false)}}><UserPlus size={16} /> Leads</div> */}
            {/* <div style={styles.dropdownItem} onClick={() => {navigate("/access-control"); setShowDropdown(false)}}><ShieldCheck size={16} /> Permissions</div> */}
             <div style={styles.dropdownItem} onClick={() => {navigate("/reports/members"); setShowDropdown(false)}}><UsersRound  size={16} /> Member Report</div>
             <div style={styles.dropdownItem} onClick={() => {navigate("/reports/receipts"); setShowDropdown(false)}}><ReceiptText size={16} /> Receipt Report</div>
              {/* <div style={styles.dropdownItem} onClick={() => {navigate("/staff"); setShowDropdown(false)}}><Users size={16} /> Staff</div> */}
              <div style={styles.dropdownItem} onClick={() => {navigate("/agent-permissions"); setShowDropdown(false)}}><ShieldCheck size={16} /> Agent Screens</div>
             <div style={styles.dropdownItem} onClick={() => {navigate("/change-password"); setShowDropdown(false)}}><Lock size={16} /> Change Password</div>
             
            
            <div style={{ height: "1px", backgroundColor: "#f1f5f9", margin: "8px 0" }}></div>
            <div style={{ ...styles.dropdownItem, color: "#ef4444" }} onClick={handleLogout}><LogOut size={16} /> Logout</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MainHeader;